import ApiUtil from './api.util'
import ApiConfig from './api.config'
const platformDomain = ApiConfig.platformDomain

function fetchNoticeListInfo (params) {
  return ApiUtil.post(`${platformDomain}/v1/ebmp/main/board/notice/list.json`, params)
}

function fetchNoticeDetailInfo (params) {
  return ApiUtil.post(`${platformDomain}/v1/ebmp/main/board/notice/detail.json`, params)
}

function fetchNoticeWrite (params) {
  return ApiUtil.postIncludeUploadFile(`${platformDomain}/v1/ebmp/main/board/notice/write.json`, params)
}

function deleteNotice (params) {
  return ApiUtil.post(`${platformDomain}/v1/ebmp/main/board/notice/delete.json`, params)
}

export { fetchNoticeListInfo, fetchNoticeDetailInfo, fetchNoticeWrite, deleteNotice }

